export default "__VITE_ASSET__CWxkKVVy__"